'use client';

import { useEffect } from 'react';
import { toast } from 'sonner';

export default function PwaRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
      return;
    }

    const register = async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          if (!newWorker) {
            return;
          }

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              toast('2xora updated', {
                description: 'A newer offline-ready version is available after refresh.',
              });
            }
          });
        });
      } catch (error) {
        console.error('Failed to register service worker:', error);
      }
    };

    void register();
  }, []);

  return null;
}
